export default __webpack_public_path__ + "static/media/home-coin.aa63f153.png";